// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"

// Custom Turbo Stream action for redirects
Turbo.StreamActions.redirect = function() {
  const url = this.getAttribute("url")
  if (url) {
    Turbo.visit(url)
  }
}
